import React from 'react'
import './NeedHelp.css';

const NeedHelp = () => {

  const handleStartNowClick = () => {
    window.location.href = 'sms:213-600-7282';
  }

  return (
    <div>
        <div className='needHelp-container'>
            <h2 className='needHelp-heading'>Need Help Choosing?</h2>
            <p className='needHelp-paragraph'>
            Discover the right <span className='bold-text'>Pawsible Plan</span> for you and your pet — built to make every visit easier, more rewarding, and more affordable.  
            </p>
            <div className='needHelp-button-container'>
                <button className="needHelp-button" onClick={handleStartNowClick}>Chat</button>
            </div>
            <p className='needHelp-subparagraph'>
            Chat with our team to explore more.
            </p>
        </div>
    </div>
  )
}

export default NeedHelp;